import Model from './model';

import { hashify } from '../utils/arrays';





export default Model.extend( {

    endpoint: 'types', responseAt: 'newstype',
    
    defaults() {
        return {
            name: '',
            cluster: null,
            group_id: null, 
            period_of_review_in_sec: undefined,
            deadline_type: 'AT_CREATE',
            default_type: 'f',
            departments: [],
            icon: 'default_icon.png',
            role_ids: null, __all_roles_available: undefined
        };
    },

    customParser(payload) {
        if (payload.period_of_review_in_sec)
            payload.period_of_review_in_sec = +payload.period_of_review_in_sec;

        return payload;
    },

    diff(another) {
        const { 
            __all_roles_available,
            role_ids,
            ...others
        } = hashify( Model.prototype.diff.call( this, another ),
            diff => [diff.attrName, diff] );

        const diff = Object.values( others );

        if (__all_roles_available)
            if (__all_roles_available.newValue)
                return another.get( 'role_ids' ) === null
                    ? diff
                    : [...diff, { attrName: 'role_ids', newValue: null }];
            else 
                return [...diff, { attrName: 'role_ids', newValue: this.get( 'role_ids' ), oldValue: null }];
        else if (role_ids)
            return [...diff, role_ids];

        return diff;
    },
    
} );


// WEBPACK FOOTER //
// ./src/js/model/newstype.js